// extracted by mini-css-extract-plugin
export default {"tableHeaderColumn":"tableHeaderColumn-Ch2hO","title":"title-JjAkY","icon":"icon-T8pCI","cursorPointer":"cursorPointer-a4S6E"};